export default __webpack_public_path__ + "static/floris-90f1f4b9838dbe2c9e76c91ff958e82e.jpg";